var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":_vm.label}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.required)?_c('span',{staticClass:"text-danger"},[_vm._v(" *")]):_vm._e()]),_c('v-text-field',_vm._g(_vm._b({attrs:{"dense":"","color":"blue darken-2","rules":_vm.rules}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }